import { render } from "./FireHazmatGraph.vue?vue&type=template&id=30b5567e"
import script from "./FireHazmatGraph.vue?vue&type=script&lang=ts"
export * from "./FireHazmatGraph.vue?vue&type=script&lang=ts"
script.render = render

export default script